import { Component, Inject, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BetStatusList } from "src/_constants/bet_filters";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { Location } from "@angular/common";
import * as moment from "moment";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { VoidBetsModalComponent } from "../bets-settlements/bets-settlements.component";

@Component({
  selector: 'app-market-bets-settlement',
  templateUrl: './market-bets-settlement.component.html',
  styleUrls: ['./market-bets-settlement.component.scss']
})
export class MarketBetsSettlementComponent implements OnInit {
  providerId = "";
  sportId = "";
  sportName = "";
  openDate = 0;
  eventId = "";
  marketId = "";
  marketName = "";
  marketType = "";
  eventName = "";
  status = "";
  bets: any;
  selected: any = {
    startDate: moment(),
    endDate: moment(),
  };
  isDisabled = true;
  AllBets = false;
  selectedBets = [];

  displayTableColumns = [
    "Date",
    "Bet Id",
    "Status",
  ];
  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private appService: AppService,
    public dialog: MatDialog,
    private location: Location,
  ) {}

  ngOnInit() {
    this.activeRouter.queryParams.subscribe((params) => {
      this.providerId = params["providerId"];
      this.sportId = params["sportId"];
      this.sportName = params["sportName"];
      this.eventId = params["eventId"];
      this.openDate = parseInt(params["openDate"]);
      this.marketId = params["marketId"];
      this.marketName = params["marketName"];
      this.marketType = params["marketType"];
      this.eventName = params["eventName"];
      this.status = params["status"];
    });
    this.getMarketBets();
  }

  getMarketBets() {
    try {
      let filters = {
        providerId: this.providerId,
        sportId: this.sportId,
        eventId: this.eventId,
        marketId: this.marketId,
        status: this.status,
      }
      this.appService
        .getMarketsBets(filters)
        .subscribe((response) => {
            this.bets = response.bets
        });
    } catch (err) {
      console.log(err);
    }
  }

  goBack = () => {
    this.location.back();
  };

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  onCheckingBet(checked, item) {
    if (checked) {
      this.selectedBets.push(item);
      this.isValid();
    } else {
      let index = this.selectedBets.indexOf(item);
      this.selectedBets.splice(index, 1);
      this.isValid();
    }
  }

  isValid() {
    if (this.selectedBets.length >= 1) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  voidBets() {
    try {
      let dialogRef = this.dialog.open(VoidBetsModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          title: "market",
          betIds:this.selectedBets,
          providerId: this.providerId,
          sportId: this.sportId,
          eventId: this.eventId,
          marketId: this.marketId,
          marketName: this.marketName,
          marketType: this.marketType,
          status: this.status,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getMarketBets();
          this.isDisabled = true;
        }
      });
    } catch (err) {}
  }
}